<template>
  <svg class="pipe-overlay-portal" :viewBox="viewBox" :style="style">
    <slot />
  </svg>
</template>

<script>
// Teleport manual (Vue 2 nao tem <Teleport>): move o proprio $el para o
// `.view-canvas` no mounted e se remove no beforeDestroy. Leva SO a camada
// editavel do cano (hit-lines de movimento/insert, guias de snap e handles de
// vertice) para um SVG com z-index alto, ficando acima de QUALQUER componente do
// dashboard — enquanto o CORPO do cano permanece inline no wrapper, na sua
// "Ordem" (z). Espelha o createPortal do Syncou (pipe-component.tsx), que so
// eleva a camada editavel.
//
// Alvo: `.view-canvas` (ancestral acima de todos os `.componente`, mas dentro do
// `.md-app-container` do vue-material — que tem `transform` e cria um stacking
// context proprio, aprisionando menu/forms). Ficar no canvas (e nao no
// document.body) mantem o portal ABAIXO do menu (10000)/form (10001) via
// z-index, mas ACIMA dos componentes.
//
// POSICIONAMENTO: nao usa getBoundingClientRect (que dependia de timing e
// desalinhava na re-selecao). Recebe `transform` ja pronto (espelhando o
// translate/scale do wrapper .componente, via props reativas componente.x/y +
// offset de drag ao vivo). Como o svg fica em left:0/top:0 dentro do canvas, o
// mesmo transform do wrapper o coloca exatamente sobre o cano — puramente
// reativo, sem leitura de layout.
export default {
  name: 'PipeOverlayPortal',
  props: {
    // Mesmo viewBox do SVG inline do cano, para as coords locais baterem.
    viewBox: {
      type: String,
      required: true,
    },
    // Largura/altura em px (bbox do cano), iguais ao SVG inline.
    width: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    // transform CSS espelhando o do wrapper .componente (translate + scale).
    transform: {
      type: String,
      required: true,
    },
    // Elemento .view-canvas onde ancorar (resolvido pelo pai, que persiste entre
    // selecoes). Fallbacks abaixo caso venha null.
    target: {
      default: null,
      validator: (v) => v === null || v instanceof Element,
    },
    zIndex: {
      type: Number,
      default: 9990,
    },
  },
  computed: {
    style() {
      return {
        position: 'absolute',
        left: 0,
        top: 0,
        width: this.width + 'px',
        height: this.height + 'px',
        transform: this.transform,
        overflow: 'visible',
        // O container nao intercepta o ponteiro; so os elementos interativos
        // (hit-lines/handles) reativam pointer-events.
        pointerEvents: 'none',
        zIndex: this.zIndex,
      }
    },
  },
  mounted() {
    // Alvo do teleport, robusto contra a re-montagem (na 2a selecao o teleport
    // manual pode deixar o $el momentaneamente destacado, fazendo closest()
    // retornar null → cairia no body e desalinharia). Prioriza o `target` vindo
    // do pai (referencia estavel), depois closest, depois querySelector.
    const target =
      this.target ||
      this.$el.closest('.view-canvas') ||
      document.querySelector('.view-canvas') ||
      document.body
    target.appendChild(this.$el)
  },
  beforeDestroy() {
    const el = this.$el
    if (el && el.parentNode) {
      el.parentNode.removeChild(el)
    }
  },
}
</script>

<style scoped></style>
